export function mapSocialIcon(url: string) {
  const socialIconMap = {
    "facebook.com": "i-cib-facebook",
    "twitter.com": "i-cib-twitter",
    "x.com": "i-cib-twitter",
    "instagram.com": "i-cib-instagram",
    "youtube.com": "i-cib-youtube",
    "linkedin.com": "i-cib-linkedin",
    "tiktok.com": "i-cib-tiktok",
  };

  try {
    const domain = new URL(url).hostname.toLowerCase().replace(/^www\./, "");

    const icon = socialIconMap[domain as keyof typeof socialIconMap];
    if (!icon) throw new Error(`Média social introuvable ${url}`);

    return icon;
  }
  catch {
    return "i-lucide-globe";
  }
}
